import { Box, styled, Typography, TextField } from '@mui/material';
import CustomContainer from '../../../components/singleComponents/grids/Container';
import Logo from '../../../components/singleComponents/logo/Logo';

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '0 20px',
  height: '100vh',
  [theme.breakpoints.up('md')]: {
    justifyContent: 'center',
    margin: '0 auto',
  },
}));

export const SubtitleStyled = styled(Typography)({
  marginBottom: '23px',
});

export const Input2Styled = styled(TextField)({
  marginBottom: '40px',
  padding: '0',
  '& span': {
    margin: '0',
    position: 'relative',
    width: '56px',
  },
});

export const LinkContainerStyled = styled(CustomContainer)({
  marginTop: '16px',
});

export const ContainerStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

export const LogoContainerStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '25vh',
  [theme.breakpoints.up('md')]: {
    height: '100vh',
    width: '50vw',
  },
}));

export const LogoStyled = styled(Logo)(({ theme }) => ({
  width: '150px',
  [theme.breakpoints.up('md')]: {
    width: '280px',
  },
}));
